export const getAddress = ({callback, lat, lng}) => {
  let geocoder = new qq.maps.Geocoder({
    complete: function (result) {
      let city = ''
      try{
        city = result.detail.addressComponents.city
      }catch(e) {}
      // alert('当前城市：'+city)
      typeof callback == 'function' && callback(city)
    }
  });
  var coord = new qq.maps.LatLng(lat, lng);
  geocoder.getAddress(coord)
}